import createReactClass from 'create-react-class';
import React from 'react';
import _ from 'underscore';
import Constants from '../constants/constants';
import { Modal, Button } from 'react-bootstrap';


import { formValidation as FormValidator} from "../util/formValidation";

import { ErrorAction } from '../actions/errorActions';
import { ServerActions } from '../actions/serverActions';

import { subdivisionStore } from '../stores/subdivision';
import { userStore } from '../stores/user';

var selectedSub;
var selectableSubList;

export const BorderingFlagModal = createReactClass({
    getInitialState: function () {
        //Load the selected subdivision and the list of available subdivision
        selectedSub = subdivisionStore.getSelectedSub();
        selectableSubList = subdivisionStore.getEntireSubList();
        var flags = [{ mp: '', mpSuffix: '', subdivision: '', errors: [] }];
        if (this.props.restriction.borderingFlags.length > 0) {
            flags = this.props.restriction.borderingFlags;
            for (var i = 0; i < flags.length; i++) {
                var mp = "" + flags[i].mp;
                if (mp.indexOf(".") === -1) {
                    flags[i].mp += ".0";
                }
            }
        }
        flags = flags.map(function (flag) {
            flag.errors = [];
            return flag;
        });
        var tip = this.props.tip;
        return { showModal: false, flags: flags, generalError: '', disableAddButton: false, tip: tip };
    },
    cancel: function () {
        this.setState({ showModal: false });

    },

    close: function () {
        const { flags = [] } = this.state;
        // if screen has only default row
        if (flags.length <= 1) {
            //check for empty records
            const allEmpty = flags.every(f => !f.mp && !f.subdivision);
            if (allEmpty) {
                // update flag with empty array
                this.props.actionCreator.borderingFlagModalClosed([]);
                this.setState({ showModal: false });
                return;
            }
        }
        const hasAnyError = flags.some(flag => flag?.errors?.length);

        //if any errors do not permit to close the modal...
        if (hasAnyError) {
            ErrorAction.showModalError('Please fix the errors on bordering flags before closing the window');
            //window.alert('Please fix the errors on bordering flags before closing the window');
            return;
        }
        const filteredFlags = flags.filter(f => f.mp || f.subdivision);
        //check to see if any required fields were left blank and prevent closing if so
        var validity = FormValidator.checkBFlagValidity(filteredFlags);
        if (!validity.valid) {
            //display
            this.setState({ flags: validity.flags });
            return;
        }

        this.props.actionCreator.borderingFlagModalClosed(filteredFlags);
        this.setState({ showModal: false });
    },

    open: function () {
        const newState = this.getInitialState();
        this.setState({ ...newState, showModal: true, disableAddButton: false });
    },

    onChange: function (event) {
        const { flags } = this.state;
        const { id, value, className } = event.target;
        //id is in the format "field_index" (ie mp_0 is the mp field at index 0 of the rows)
        const [field, index] = id.split("_");
        //trim value if value is string
        const newValue = typeof value === 'string' ? value?.trim()?.toUpperCase() : value;

        if (["mpInput", "suffixInput"].includes(className)) {
            this.regex = className === "mpInput" ? /^[0-9.\b]+$/ : /^[a-zA-Z\b]+$/;
            // check given value is empty or valid
            if (value === '' || this.regex.test(value)) {
                flags[index][field] = newValue;
            }
        } else {
            // set value for field
            flags[index][field] = newValue;
        }
        // update flags 
        this.setState({ flags: [...flags] });
    },

    onBlur: function (event) {

        var eventId = event.target.id.split('_');
        var newState = this.state;

        if (!event.target.checkValidity()) {//when clicking out of a field, we check all the validations including required..
            //this means the validators failed after the user clicked out of the field, so store this on the model...
            if (event.target.validity.patternMismatch) {
                error = 'Please enter a valid ' + event.target.name;
            }
            else {
                var error = event.target.name + ': ' + event.target.validationMessage;
            }
            //add the error
            //id is in the format "field_index" (ie mp_0 is the mp field at index 0 of the rows)

            //set the value on the row errors
            //reduce the errors on this row to a the unique list
            newState.flags[eventId[1]].errors.push({ field: event.target.id, error: error });

            newState.flags[eventId[1]].errors = _.uniq(newState.flags[eventId[1]].errors, false, function (e) {
                return e.error
            });

        }
        else {//do this so that the error is removed if it is cleared

            //remove the error

            //clear all the errors for the field that was blurred
            newState.flags[eventId[1]].errors;
            if (newState.flags[eventId[1]].errors != null) {
                newState.flags[eventId[1]].errors = newState.flags[eventId[1]].errors.filter(function (er) {
                    return er.field !== event.target.id
                });
            }

            if (eventId[0] === 'mp') {
                var noDecimalRegex = new RegExp(Constants.Regex.mpRegexNoDecimal);
                var noLeadingDecimalRegex = new RegExp(Constants.Regex.mpRegexNoLeadingDecimal);
                if (noDecimalRegex.test(event.target.value)) {
                    newState.flags[eventId[1]].mp = newState.flags[eventId[1]].mp + '.0';
                }
                if (noLeadingDecimalRegex.test(event.target.value)) {
                    newState.flags[eventId[1]].mp = '0' + newState.flags[eventId[1]].mp;
                }
            }
            else if (eventId[0] === 'subdivision') {
                newState.flags[eventId[1]].subdivision = newState.flags[eventId[1]].subdivision.toUpperCase();
            }
            //now that we've cleaned up the current errors, lets check for server errors

        }

        //check against the server now

        var validity = FormValidator.checkBFlagValidity(newState.flags);
        //assume no errors unless we find one
        newState.disableAddButton = false;
        //get a local copy of the state so we can modify it
        validity.flags.forEach(function (flag, i) {
            if (flag.errors.length === 0) {

                var defValidation = ServerActions.validateBorderingFlag(flag, i);
                var componentThis = this;
                defValidation.done(function (data, status, xhr) {
                    //convert the flag & errors from data into a flag for the modal, then call setState to display the errors
                    var row = data.row;

                    var errors;
                    if (data.errors != null) {
                        errors =  data.errors.map(function (er) {
                            return { field: "tss_" + row, error: er.message };
                        });
                        newState.disableAddButton = true;
                    }


                    newState.flags[row].errors = errors;
                    componentThis.setState(newState);

                }).fail(function (data, status, xhr) {

                    if (data.responseJSON) {
                        var row = data.responseJSON.data.row;
                        if (row >= 0) {
                            var errors = [{
                                field: "tss_" + row,
                                error: "An error occurred validating this bordering flag"
                            }];
                            newState.flags[row].errors = errors;
                            componentThis.setState(newState);
                        }
                    }
                    else {
                        console.error('An error occurred', data.responseText)
                    }

                });
            }
            else {
                //found at least one error
                newState.disableAddButton = true;
                //remove any TSS errors that might be on this flag
                newState.flags[i].errors = newState.flags[i].errors.filter(function (er) {
                    return !/tss_./.test(er.field)
                });
            }
        }, this);
        this.setState(newState);

    },

    addBorderingFlag: function (event) {

        //only add a new row if all the existing rows are filled in
        var newState = this.state;

        //if there are any blank rows, don't add a new row and put an error on those rows
        var blankFlags = this.state.flags.filter(function (flag) {
            return !flag.mp || !flag.subdivision
        });
        if (blankFlags.length > 0) {
            newState.generalError = 'Please fill out Mp and Subdivision on all flags before adding a new flag';
        }
        else {
            if (newState.flags.length < Constants.MaxValues.MAX_BORDERING_FLAG_COUNT) {
                newState.generalError = '';
                newState.flags.push({ mp: '', mpSuffix: '', subdivision: "", errors: [] });
            }
        }
        this.setState(newState);
    },

    rowDelete: function (event, i) {
        var newState = this.state;
        newState.flags.splice(parseInt(event.target.id), 1);
        if (newState.flags.length === 0) {
            this.addBorderingFlag();
            //enable the button cause we're removed all the flags
            newState.disableAddButton = false;
        }
        this.setState(newState);
    },

    render: function () {
        var isReadOnly = this.props.isReadOnly;
        var clsName = "", styleName = "";
        var userRole = userStore.getSelectedRole();
        var tip = this.state.tip;
        if (this.state.flags) {
            var borderingFlags = this.state.flags.map(function (flag, i) {
                return (
                    <DetailRow
                        key={i}
                        flag={flag}
                        ref={"row" + i}
                        isReadOnly={isReadOnly}
                        rowDelete={this.rowDelete}
                        onChange={this.onChange}
                        onBlur={this.onBlur}
                        row={i}
                        tip={tip}
                    />
                )
            }, this);//'this' passes the context into the map function so that "this.rowDelete" references the component rather than the window.
        }
        if (userRole.indexOf(Constants.Roles.FIELD_USER) !== 0 && this.props.restriction.id !== "" && this.props.borderFlagCount > 0) {
            clsName = "commentBorderExist";
            styleName = "info";
        } else {
            clsName = "btn";
            styleName = "info";
        }


        return (
            <div>
                <Button
                    id="borderingFlagButton"
                    bsClass={clsName}
                    bsStyle={styleName}
                    disabled={this.props.isDisabled}
                    onClick={this.open}>
                    Bordering Flags: {this.props.borderFlagCount}
                </Button>
                <Modal
                    backdrop='static'
                    dialogClassName="boarderFlagModal"
                    onHide={this.cancel}
                    show={this.state.showModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Bordering Flags</Modal.Title>
                    </Modal.Header>

                    <div className='modal-body'>
                        <div>
                            {isReadOnly ? null : (<Button id="addBorderingFlagButton"
                                onClick={this.addBorderingFlag}
                                disabled={isReadOnly || this.state.flags.length > (Constants.MaxValues.MAX_BORDERING_FLAG_COUNT - 1)}
                                bsSize='small'
                                bsStyle='info'>
                                New Bordering Flag
                            </Button>)}
                            <span className="modalGeneralError">
                                {this.state.generalError}
                            </span>
                        </div>
                        <div className="container inheritwidth">
                            {borderingFlags}
                        </div>
                    </div>
                    <div className='modal-footer'>
                        {isReadOnly ? null : (<Button bsStyle='primary'
                            disabled={isReadOnly || this.state.disableAddButton}
                            //hidden={this.state.disableAddButton}
                            id="borderFlagAddToRequestButton"
                            onMouseDown={this.close}>Save</Button>)}
                        <Button id="borderFlagCancelButton"
                            //hidden={this.state.disableAddButton}
                            onMouseDown={this.cancel}>Cancel</Button>
                    </div>
                </Modal>
            </div>
        );
    },
});


var DetailRow = new createReactClass({

    render: function () {
        //adding subdivisions to the drop down
        var subdivisions = [];
        if (selectableSubList) {
            subdivisions = selectableSubList.map(function (sub, i) {
                if (selectedSub !== sub.name) {
                    return (<option key={i + 1} value={sub.name}>{sub.name}</option>);
                }
            });
        }
        subdivisions.splice(
            0,
            0,
            <option disabled key={0} value="">
                Select...
            </option>
        );

        var mpId = "mp_" + this.props.row;
        var suffixId = "mpSuffix_" + this.props.row;
        var subdivisionId = "subdivision_" + this.props.row;
        var errors;

        if (this.props.flag.errors != null) {
            errors = this.props.flag.errors.map(function (er, i) {
                return (<div key={i}>{er.error}</div>)
            });
        }
        var isReadOnly = this.props.isReadOnly;
        var tip = this.props.tip;
        return (
            <div className="row flagRow">
                <div className="gridLayoutDataContainer borderingFlagRow">
                    <label >
                        Subdivision:
                    </label>
                    <select id={subdivisionId}
                        disabled={isReadOnly}
                        onChange={this.props.onChange}
                        onBlur={this.props.onBlur}
                        value={this.props.flag.subdivision}
                        name="Subdivision"
                        style={{ width: '150px' }}
                        title={tip}
                        required>
                        {/*<option value="" disabled>Select...*/}
                        {/*</option>*/}
                        {subdivisions}
                    </select>
                    <label>
                        MilePost
                    </label>
                    <input type="text"
                        id={mpId}
                        disabled={isReadOnly}
                        className="mpInput"
                        name="Mp"
                        onChange={this.props.onChange}
                        onBlur={this.props.onBlur}
                        value={this.props.flag.mp}
                        maxLength="6"
                        placeholder="xxxx.x"
                        pattern={Constants.Regex.mpRegex}
                        title={tip}
                        required />
                    <input type="text"
                        id={suffixId}
                        disabled={isReadOnly}
                        className="suffixInput"
                        name="Suffix"
                        onChange={this.props.onChange}
                        onBlur={this.props.onBlur}
                        value={this.props.flag.mpSuffix}
                        maxLength="1"
                        title={isReadOnly ? tip : ""}
                        pattern={Constants.Regex.suffixRegex} />

                    <a className="btn btn-sm btn-default"
                        id=""
                        onClick={this.props.rowDelete}
                        disabled={isReadOnly}
                        title="Delete Restriction">
                        <span id={this.props.row} className="glyphicon glyphicon-remove"></span>
                    </a>
                    <span className="informationRadiatorErrorItem">
                        {errors}
                    </span>
                </div>
            </div>
        );
    },
});
